import styled from 'styled-components';

const BasicDivFlex = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export default BasicDivFlex;
